import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import { Grid } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import Icons from 'consts/icons';
import { formStyles } from 'consts/styles/Form';

import useSubscriptionsStyles from './SubscriptionsUseSharedStyles';
import useStyles from './SubscriptionsTreeViewUseStyles';

const SubscriptionsList = props => {
  const { subscriptions } = props;
  const [expandedCards, setExpandedCards] = React.useState({});
  const subtitles = useSelector(state => state.language.adminZone);
  const subscriptionsClasses = useSubscriptionsStyles();

  const classes = useStyles();
  const formClasses = formStyles();

  const handleExpandClickChildren = (uid = '') => {
    setExpandedCards({
      ...expandedCards,
      [uid]: !expandedCards[uid],
    });
  };

  const returnSubscriptionCard = subscription => (
    <div>
      <Grid
        container
        className={`${classes.Subscription}__organization__border__end`}
      >
        <Grid item xs={12}>
          <CardContent
            className={clsx({
              [`${classes.ReturnSubscriptionTreeView}__card ${classes.ReturnSubscriptionTreeView}__card__children ${classes.ReturnSubscriptionTreeView}__card--box-shadow`]: subscription?.uid,
              [`${subscriptionsClasses.ExistingWithTree}__card`]: !subscription?.uid,
              [`${classes.ReturnSubscriptionTreeView}__card__main-border`]: expandedCards[
                subscription?.uid
              ],
            })}
            key={subscription?.uid}
          >
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="body2" align="left">
                  {subtitles.subscriptions.id_}: <br />
                  {subtitles.subscriptions.organization_}: <br />
                  {subtitles.subscriptions.start_}: <br />
                  {subtitles.subscriptions.stop_}: <br />
                  {subtitles.subscriptions.created_}: <br />
                  {subtitles.subscriptions.active_}:{' '}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" align="right">
                  {subscription.uid}
                  <br />
                  {subscription.organization}
                  <br />
                  {subscription.start}
                  <br />
                  {subscription.stop}
                  <br />
                  {subscription.created}
                  <br />
                  {subscription.active ? 'Active' : 'Not active'}
                </Typography>
              </Grid>
            </Grid>

            {subscription.payments?.length > 0
              ? returnPaymentCard(subscription.payments, subscription.uid)
              : ''}
          </CardContent>
        </Grid>
      </Grid>
    </div>
  );

  const returnPaymentCard = (payments, subUid) => (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <CardActions
            onClick={() => handleExpandClickChildren(subUid)}
            className={clsx(
              `${subscriptionsClasses.ExistingWithTree}__expand-bar ${classes.ReturnSubscriptionTreeView}__card`,
              {
                [`${classes.ReturnSubscriptionTreeView}__card__children ${subscriptionsClasses.ExistingWithTree}__expand-bar`]: subUid,
                [`${subscriptionsClasses.ExistingWithTree}__card`]: !subUid,
              }
            )}
            disableSpacing
          >
            <Typography variant="h5">
              {subtitles.subscriptions.payments.header_}
            </Typography>
            <IconButton
              className={clsx(
                `${subscriptionsClasses.ExistingWithTree}__expand-bar__arrow`,
                {
                  [`${subscriptionsClasses.ExistingWithTree}__expand-bar__arrow--open`]: expandedCards[
                    subUid
                  ],
                }
              )}
              aria-label="Show payments"
            >
              <Icons.Navigation.Down />
            </IconButton>
          </CardActions>
          {payments.map((payment, index) => (
            <Collapse
              key={index}
              unmountOnExit
              in={expandedCards[subUid]}
              className={`${classes.ReturnSubscriptionTreeView}__organization--padding-left`}
            >
              <Grid container>
                {payments[payments.length - 1].uid === payment.uid ? (
                  <Grid item xs={1}>
                    <div
                      className={`${classes.ReturnSubscriptionTreeView}__organization__border__bottom-left ${classes.ReturnSubscriptionTreeView}__organization--border-left`}
                    ></div>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={1}
                    className={`${classes.ReturnSubscriptionTreeView}__organization--border-left`}
                  >
                    <div
                      className={`${classes.ReturnSubscriptionTreeView}__organization__border__bottom-left ${classes.ReturnSubscriptionTreeView}__organization--margin-left`}
                    ></div>
                  </Grid>
                )}
                <Grid item xs={11}>
                  <Grid container>
                    <Grid item xs={1}>
                      <div
                        className={`${classes.Subscription}__organization__border__end`}
                      ></div>
                    </Grid>
                    <Grid item xs={12}>
                      <CardContent
                        className={clsx({
                          [`${classes.ReturnSubscriptionTreeView}__card ${classes.ReturnSubscriptionTreeView}__card__children ${classes.ReturnSubscriptionTreeView}__card--box-shadow`]: payment?.uid,
                          [`${subscriptionsClasses.ExistingWithTree}__card`]: !payment?.uid,
                          [`${classes.ReturnSubscriptionTreeView}__card__main-border`]: expandedCards[
                            payment?.uid
                          ],
                        })}
                        key={payment?.uid}
                      >
                        <Grid>
                          <Grid>
                            <Typography
                              variant="body2"
                              component="p"
                            ></Typography>
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid item xs={6}>
                            <Typography variant="body2" align="left">
                              {subtitles.subscriptions.id_}: <br />
                              {subtitles.subscriptions.payments.created_}:{' '}
                              <br />
                              {subtitles.subscriptions.payments.invoice_number_}
                              : <br />
                              {
                                subtitles.subscriptions.payments.payment_till_
                              }: <br />
                              {subtitles.subscriptions.payments.payment_booked_}
                              : <br />
                              {subtitles.subscriptions.payments.discount_}:{' '}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="body2" align="right">
                              {payment.uid}
                              <br />
                              {payment.created}
                              <br />
                              {payment.invoice_number}
                              <br />
                              {payment.payment_till}
                              <br />
                              {payment.payment_booked_
                                ? payment.payment_booked_
                                : '-'}
                              <br />
                              {payment.discount}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Collapse>
          ))}
        </Grid>
      </Grid>
    </div>
  );

  return (
    <div>
      <Typography
        variant="h3"
        align="center"
        className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
      >
        {subtitles.subscriptions.header_}
      </Typography>

      {subscriptions.length > 0 ? (
        subscriptions.map(sub => returnSubscriptionCard(sub))
      ) : (
        <div
          className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
        >
          {subtitles.subscriptions.noSubscriptions_}
        </div>
      )}
    </div>
  );
};

SubscriptionsList.propTypes = {
  subscriptions: PropTypes.array.isRequired,
};

export default SubscriptionsList;
